import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() { return ["form", "next"]; }
  static get values() { return { requiredUploadIds: Array }; }
  static get classes() { return ["disabled"]; }

  connect() {
    this.observer = new MutationObserver(() => this.syncNextButtons());
    this.observer.observe(this.formTarget, { childList: true, subtree: true });
  }

  disconnect() {
    this.observer.disconnect();
  }

  // Plain form.submit(): #custom-packaging-bundle-form carries no lt-single-submit and nothing
  // binds a jQuery submit handler to it (see admin_redeemed_gift_controller.js for the same
  // reasoning), so jQuery's .submit() shorthand and the native method behave identically here.
  submit(event) {
    event.preventDefault();
    this.formTarget.submit();
  }

  syncNextButtons() {
    const pending = this.requiredUploadIdsValue.some(id => document.getElementById(id));

    this.nextTargets.forEach(button => button.classList.toggle(this.disabledClass, pending));
  }
}
